import { FileOutlined, SearchOutlined } from "@ant-design/icons";
import { Collapse, ConfigProvider, Empty, Input, Pagination, Select, Spin, Table } from "antd";
// import Search from "antd/es/input/Search";
import { ReactComponent as Search } from "asset/address/search.svg";
import axios from "axios";
import style from "css/notice.module.css";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { closeAlert, openAlert } from "redux/slices/alertSlice";

// 'ant-design - collapse 참고
function Notice() {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const { Panel } = Collapse;
    const searchParams = new URLSearchParams(window.location.search);
    const noticeID = searchParams.get('ID');
    const [isSearch, setIsSearch] = useState(true);
    const [search, setSearch] = useState('');
    const [notice, setNotice] = useState([
        // {
        //     ID: "",
        //     TITLE: "",
        //     CONTENT: "",
        //     WRITER: "",
        //     DATE: "",
        //     ATT_FILES: [],
        //     isOpen: false,
        // }
    ]);
    // 페이징 정보
    const [page, setPage] = useState({
        totalCount: 0,
        rowCount: 10,
        currentPage: 1,
        maxPage: 5,
    });

    // collapse control
    // const handleOpen = (id) => {
    //     const newNotices = notice.map((nt) => {
    //         if (nt.ID === id) {
    //             return { ...nt, isOpen: !nt.isOpen };
    //         }
    //         // 각 탭별로 따로 컨트롤
    //         // return nt;

    //         // 탭 하나 열리면 다른 탭들은 close
    //         return { ...nt, isOpen: false };
    //     });

    //     setNotice(newNotices);
    // }

    // 검색 필터
    // const selectOptions = [
    //     { value: "전체", label: "전체" },
    //     { value: "일반회의실", label: "일반회의실" },
    //     { value: "영상회의실", label: "영상회의실" },
    //     { value: "화상회의", label: "화상회의" },
    //     { value: "즉시미팅", label: "즉시미팅" },
    // ];
    // const handleSelectValue = (value) => {
    //     setSearch({
    //         ...search,
    //         SEARCH_TYPE: value,
    //     });
    // };

    // 공지사항 데이터 불러오기
    const getNoticeList = useCallback(() => {
        const config = {
            params: {
                // SEARCH_TYPE: search.SEARCH_TYPE,
                SEARCH_TXT: search,
                // ROW_COUNT: page.rowCount,
                // PAGE_COUNT: (page.currentPage - 1) * page.rowCount,
            },
        };
        // axios
        //     .get("/notice/total", config)
        //     .then((res) => {
        //         if (res.status === 200) {
        //             setPage({
        //                 ...page,
        //                 totalCount: res.data,
        //             });
        //         }
        //     })
        //     .catch(() => {
        //         console.log("notice total error");
        //     });
        axios
            .get("/notice/data", config)
            .then((res) => {
                if (res.status === 200) {
                    let list = [];
                    for (let i = 0; i < res.data.length; i++) {
                        list.push({
                            // KEY: i + 1,
                            key: res.data[i].ID,
                            ID: i + 1,
                            TITLE: res.data[i].TITLE,
                            CONTENT: res.data[i].CONTENT,
                            WRITER: res.data[i].INPUT_ID,
                            DATE: res.data[i].INPUT_DT,
                            ATT_FILES: res.data[i].ATTACHMENT,
                            isOpen: false,
                        });
                    }
                    setNotice(list);
                }
            })
            .catch(() => {
                console.log("notice total error");
            })
    }, [search]);

    useEffect(() => {
        if (isSearch) {
            setLoading(true);
            getNoticeList();
            setIsSearch(false);
            setLoading(false);
        }
    }, [getNoticeList, isSearch]);

    const columns = [
        // Table.SELECTION_COLUMN,
        Table.EXPAND_COLUMN,
        {
            title: '#',
            dataIndex: 'ID',
            key: 'ID',
            align: 'center',
            sorter: (a, b) => a.ID - b.ID,
        },
        {
            title: t("LIST.TITLE"),
            dataIndex: 'TITLE',
            key: 'TITLE',
            align: 'center',
        },
        {
            title: t("LIST.WRITER"),
            dataIndex: 'WRITER',
            key: 'WRITER',
            align: 'center',
        },
        {
            title: t("LIST.WRITE_DATE"),
            dataIndex: 'DATE',
            key: 'DATE',
            align: 'center',
        },
    ];

    const [isNotice, setIsNotice] = useState(true);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const setNoticeId = useCallback(() => {
        if (noticeID === "") {
            setExpandedRowKeys([]);
        } else {
            setExpandedRowKeys([...expandedRowKeys, Number(noticeID)]);
        }
    }, [expandedRowKeys, noticeID])

    useEffect(() => {
        if (isNotice) {
            setNoticeId();
            setIsNotice(false);
        }
    }, [isNotice, setNoticeId])

    const handleRowExpand = (expanded, record) => {
        // 다수 확장
        // const keys = expanded ? [...expandedRowKeys, record.key] : expandedRowKeys.filter(key => key !== record.key); 

        // 1개씩만 확장
        const keys = expanded ? [record.key] : expandedRowKeys.filter(key => key !== record.key);

        setExpandedRowKeys(keys);
    }

    const expandedRowRender = record => {
        return (
            <div className={style.notice_table_expand}>
                <div dangerouslySetInnerHTML={{ __html: record.CONTENT }} />
                {
                    record.ATT_FILES.length > 0
                        ?
                        <div className={style.notice_table_expand_attachment}>
                            <span>{t("LABEL.ATTACHMENT")}</span>
                            {
                                record.ATT_FILES.map((file, idx) => (
                                    <div style={{ marginTop: 5 }}>
                                        <FileOutlined style={{ marginRight: 10 }} />
                                        {/* <a
                                            key={"file_" + idx}
                                            download={file.FILE_NM}
                                            href={file.FILE_URL}
                                            target='_blank' rel='noreferrer'
                                            className="cursor"
                                        >
                                            {file.ORI_FILE_NM}
                                        </a> */}
                                        <span
                                            onClick={() => downloadFile(file)}
                                            className='cursor'
                                        >
                                            {file.ORI_FILE_NM}
                                        </span>
                                    </div>
                                ))
                            }
                        </div>
                        :
                        <></>
                }
            </div>
        )
    }

    const downloadFile = (params) => {
        axios.post('/notice/downloadFile', params, { responseType: 'blob' })
            .then((response) => response.data)
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.ORI_FILE_NM);
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.ERROR_OCCURRED"),
                    submitEventHandler: () => {
                        dispatch(closeAlert());
                    },
                };
                dispatch(openAlert(obj));
            });
    };

    return (
        <div className={style.notice_container}>
            <div className={style.notice_wrapper}>
                <div className={style.notice_header}>
                    {/* <Select
                        defaultValue={search.SEARCH_TYPE}
                        style={{
                            width: 200,
                        }}
                        onChange={handleSelectValue}
                        options={selectOptions}
                    /> */}
                    <Input
                        // className={style.notice_searchinput}
                        className="inputbox-size"
                        placeholder={t("PLACEHOLDER.SEARCH.TITLE_CONTENT")}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        onKeyDown={
                            e => {
                                if (e.key === "Enter") {
                                    setIsSearch(true);
                                }
                            }
                        }
                        suffix={
                            <SearchOutlined
                                className='search-btn'
                                onClick={() => setIsSearch(true)}
                            />
                        }
                    />
                </div>
                {loading ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Spin />
                    </div>
                ) : (
                    <div className="notice-table">
                        <Table
                            // className='notice-table'
                            dataSource={notice}
                            columns={columns}
                            loading={loading}
                            locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
                            expandedRowRender={expandedRowRender}
                            onExpand={handleRowExpand}
                            expandedRowKeys={expandedRowKeys}
                            rowClassName='cursor'
                            onRow={(record) => ({
                                onClick: () => {
                                    // console.log("Row click " + record.key);
                                    if (record.key === expandedRowKeys[0]) {
                                        setExpandedRowKeys([]);
                                    } else {
                                        let tmp = [];
                                        tmp.push(record.key);
                                        setExpandedRowKeys(tmp);
                                    }
                                },
                            })}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Notice;
